import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { Router } from "react-router";

import { getStore } from "./store/configureStore";
import { getHistory } from './util/configureHistory';

import { getRoutes } from "./components/Navigation";

import * as settings from "./actions/settingActions";
import * as layout from "./actions/layoutActions";
import * as vrLayout from "./actions/voortgangsrapportLayoutActions";

import * as reference from "./actions/referentieActions";

import { isOldVersion } from "./util/browserVersion.js";

import OudeBrowser from "./components/oudeBrowser/OudeBrowser";

import "../css/site.css";
import "../node_modules/toastr/build/toastr.min.css";

const store = getStore();
const history = getHistory();
const isVoortgangsrapportScope = history.getCurrentLocation().pathname.indexOf("voortgangsrapport") > -1;

store.dispatch(settings.loadSettings());
store.dispatch(isVoortgangsrapportScope ? vrLayout.loadDefaultLayout() : layout.loadDefaultLayout());
store.dispatch(reference.loadReferences());

if (isOldVersion())
	render(<OudeBrowser />, document.getElementById('app'));
else
	render(
		<Provider store={store}>
			<Router history={history}>
				{getRoutes(store)}
			</Router>
		</Provider>, document.getElementById('app')
	);
